module.exports = __webpack_public_path__ + "img/hotelFamily-9.ca66f63a.jpg";